import { required, minLength } from "vuelidate/lib/validators";

export default {
  required,
  minLength: minLength(8)
};
